"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationJumpItemMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var _PaginationItemMixin = require("./PaginationItemMixin");
/** @class PaginationJumpItemMixin */
/** @method */
var PaginationJumpItemMixin = function PaginationJumpItemMixin(props) {
  return (0, _styledToken.default)({
    marginX: 'PaginationJumpItem.marginX',
    marginY: 'PaginationJumpItem.marginY'
  }, function (_ref) {
    var marginX = _ref.marginX,
      _ref$marginY = _ref.marginY,
      marginY = _ref$marginY === void 0 ? 0 : _ref$marginY;
    return (0, _styledComponents.css)(["", " margin:", "px ", ";"], (0, _PaginationItemMixin.PaginationItemMixin)(props), marginY, marginX ? marginX + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.PaginationJumpItemMixin = PaginationJumpItemMixin;